import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../context/Authcontext";
import { useParams } from "react-router-dom";

const Profile = () => {
  const [userinfo, setuserinfo] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [editedInfo, setEditedInfo] = useState(userinfo);
  const { contextData } = useContext(AuthContext);
  const { id } = useParams();

  const getavatar = async () => {
    const response = await axios.get(
      `https://pfebackend-zbz0.onrender.com/api/user/avatar/${id}/`,
      {
        responseType: "blob",
      }
    );
    const image = document.getElementById("avatar-image1");
    const imageUrl = URL.createObjectURL(new Blob([response.data]));
    image.src = imageUrl;
  };

  const getuserinfo = async () => {
    const { data } = await axios.get(
      `https://pfebackend-zbz0.onrender.com/api/getuser/${id}/`
    );
    setuserinfo(data);
    setEditedInfo(data);
  };

  const [errorMessages, setErrorMessages] = useState({});

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedInfo({ ...editedInfo, [name]: value });
  };

  const handleSaveClick = async () => {
    const errors = validateData(editedInfo);
    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return;
    }
    setErrorMessages({});

    try {
      await axios.post(
        `https://pfebackend-zbz0.onrender.com/api/setuser/${id}/`,
        editedInfo
      );
      setIsEditing(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleCancelClick = () => {
    setEditedInfo(userinfo);
    setIsEditing(false);
  };

  const validateData = (data) => {
    const errors = {};
    if (!data.name) {
      errors.name = "Name is required";
    }
    if (!data.email) {
      errors.email = "Email is required";
    } else if (!isValidEmail(data.email)) {
      errors.email = "Email is not valid";
    }
    if (!data.phone_number) {
      errors.phone_number = "Phone number is required";
    } else if (!isValidPhoneNumber(data.phone_number)) {
      errors.phone_number = "Phone number is not valid";
    }
    return errors;
  };

  const isValidEmail = (email) => {
    const emailRegex = /\S+@\S+\.\S+/;
    return emailRegex.test(email);
  };

  const isValidPhoneNumber = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
  };

  useEffect(() => {
    getavatar();
    getuserinfo();
  }, []);

  useEffect(() => {
    getavatar();
    getuserinfo();
  }, [id]);

  return (
    <div className="user-profile-container">
      <h1>Profile Page</h1>
      <img style={{ maxWidth: "200px" }} src="" id="avatar-image1" alt="" />
      {isEditing ? (
        <form className="edit-form">
          <label>
            Name:
            <input
              type="text"
              name="name"
              value={editedInfo.name}
              onChange={handleInputChange}
            />
            {errorMessages.name && (
              <span className="error-message">{errorMessages.name}</span>
            )}
          </label>
          <br />
          <label>
            Email:
            <input
              type="email"
              name="email"
              value={editedInfo.email}
              onChange={handleInputChange}
            />
            {errorMessages.email && (
              <span className="error-message">{errorMessages.email}</span>
            )}
          </label>
          <br />
          <label>
            Phone Number:
            <input
              type="tel"
              name="phone_number"
              value={editedInfo.phone_number}
              onChange={handleInputChange}
            />
            {errorMessages.phone_number && (
              <span className="error-message">
                {errorMessages.phone_number}
              </span>
            )}
          </label>
          <br />
          <button type="button" onClick={handleSaveClick}>
            Save
          </button>
          <button type="button" onClick={handleCancelClick}>
            Cancel
          </button>
        </form>
      ) : (
        <>
          <p>{userinfo.name}</p>
          <p>{userinfo.email}</p>
          <p>{userinfo.phone_number}</p>

          {contextData.user.id === parseInt(id) && (
            <button
              type="button"
              className="Profile-edit-button"
              onClick={handleEditClick}
            >
              Edit
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default Profile;
